const { registerBlockType } = wp.blocks;
const { InspectorControls, RichText, ColorPalette, InnerBlocks } =
  wp.blockEditor;
const { PanelBody, SelectControl, Button } = wp.components;
const { Fragment } = wp.element;
const { __ } = wp.i18n;
const { useSelect } = wp.data;

// Register the custom Gutenberg block
registerBlockType('pg/list', {
  title: __('PG List', 'pg'),
  icon: 'editor-ul',
  category: 'layout',
  attributes: {
    listStyle: {
      type: 'string',
      default: 'disc',
    },
    listColor: {
      type: 'string',
      default: '',
    },
  },

  edit: ({ attributes, setAttributes, clientId }) => {
    const { listStyle, listColor } = attributes;

    const onChangeListStyle = (style) => {
      setAttributes({ listStyle: style });
    };

    const onChangeListColor = (color) => {
      setAttributes({ listColor: color });
    };

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody title={__('List Settings', 'pg')} initialOpen={true}>
            <SelectControl
              label={__('List Style', 'pg')}
              value={listStyle}
              options={[
                { label: 'Alpha', value: 'alpha' },
                { label: 'Numeric', value: 'numeric' },
                { label: 'Disc', value: 'disc' },
                { label: 'Checklist', value: 'checklist' },
              ]}
              onChange={onChangeListStyle}
            />
            <ColorPalette value={listColor} onChange={onChangeListColor} />
          </PanelBody>
        </InspectorControls>

        <ul
          className={`pg-list pg-list--${listStyle}`}
          style={{ color: listColor }}
        >
          <InnerBlocks
            allowedBlocks={['pg/list-item']}
            template={[['pg/list-item']]}
            renderAppender={false} // Disable default appender
          />
          <Button
            isSmall
            icon="plus"
            title={__('New Item', 'pg')}
            onClick={() => {
              const block = wp.blocks.createBlock('pg/list-item');
              wp.data
                .dispatch('core/block-editor')
                .insertBlock(block, undefined, clientId);
            }}
          />
        </ul>
      </Fragment>
    );
  },

  save: ({ attributes }) => {
    const { listStyle, listColor } = attributes;

    return (
      <ul
        className={`pg-list pg-list--${listStyle}`}
        style={{ color: listColor }}
      >
        <InnerBlocks.Content />
      </ul>
    );
  },
});

// Register the list item block
registerBlockType('pg/list-item', {
  title: __('PG List Item', 'pg'),
  icon: 'editor-ul',
  category: 'layout',
  parent: ['pg/list'], // This ensures it can only be used within 'pg/list'
  attributes: {
    content: {
      type: 'string',
      source: 'html',
      selector: 'li > span',
    },
    listStyle: {
      type: 'string',
      default: 'disc',
    },
    listColor: {
      type: 'string',
      default: '',
    },
  },

  edit: ({ attributes, setAttributes, clientId }) => {
    const { content, listStyle, listColor } = attributes;

    const isLastBlock = useSelect(
      (select) => {
        const { getBlockOrder, getBlockIndex } = select('core/block-editor');
        const blockOrder = getBlockOrder();
        const blockIndex = getBlockIndex(clientId);
        return blockIndex === blockOrder.length - 1;
      },
      [clientId]
    );

    const onChangeListStyle = (style) => {
      setAttributes({ listStyle: style });
    };

    const onChangeListColor = (color) => {
      setAttributes({ listColor: color });
    };

    return (
      <li className={'pg-list-item'}>
        <InspectorControls>
          <PanelBody title={__('List Item Settings', 'pg')} initialOpen={true}>
            <SelectControl
              label={__('List Style', 'pg')}
              value={listStyle}
              options={[
                { label: 'Alpha', value: 'alpha' },
                { label: 'Numeric', value: 'numeric' },
                { label: 'Disc', value: 'disc' },
                { label: 'Checklist', value: 'checklist' },
              ]}
              onChange={onChangeListStyle}
            />
            <ColorPalette value={listColor} onChange={onChangeListColor} />
          </PanelBody>
        </InspectorControls>

        <RichText
          tagName="span"
          value={content}
          onChange={(value) => setAttributes({ content: value })}
          placeholder={__('List item...', 'pg')}
        />
        <div className="pg-list-item-buttons">
          {isLastBlock && (
            <Button
              isSmall
              icon="plus"
              className={'pg-list-item-add'}
              title={__('New Item', 'pg')}
              onClick={() => {
                const block = wp.blocks.createBlock('pg/list-item');
                wp.data
                  .dispatch('core/block-editor')
                  .insertBlock(block, undefined, clientId);
              }}
            />
          )}
          <Button
            isSmall
            icon="arrow-right-alt"
            className={'pg-list-item-nested'}
            title={__('New Nested', 'pg')}
            onClick={() => {
              const block = wp.blocks.createBlock('pg/list-item');
              wp.data
                .dispatch('core/block-editor')
                .insertBlock(block, 0, clientId);
            }}
          />
          <Button
            isSmall
            icon="trash"
            className={'pg-list-item-trash'}
            title={__('Remove Item', 'pg')}
            onClick={() => {
              wp.data.dispatch('core/block-editor').removeBlock(clientId);
            }}
          />
        </div>
        <ul
          className={`pg-list pg-list--${listStyle}`}
          style={{ color: listColor }}
        >
          <InnerBlocks
            allowedBlocks={['pg/list-item']}
            renderAppender={false}
          />
        </ul>
      </li>
    );
  },

  save: ({ attributes }) => {
    const { content, listStyle, listColor } = attributes;

    return (
      <li className={'pg-list-item'}>
        <RichText.Content tagName="span" value={content} />
        <ul
          className={`pg-list pg-list--${listStyle}`}
          style={{ color: listColor }}
        >
          <InnerBlocks.Content />
        </ul>
      </li>
    );
  },
});
